"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclineTextOutputWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var MotorDeclineText_1 = require("./MotorDeclineText");
var RentersDeclineText_1 = require("./RentersDeclineText");
var WolfMotorDeclineText_1 = require("./WolfMotorDeclineText");
var services_1 = require("@falcon/services");
var HomeDeclineText_1 = require("./HomeDeclineText");
var DeclineTextOutputWidget = exports.DeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(DeclineTextOutputWidget, _super);
    function DeclineTextOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.underwritingResultArray = _this.props.interaction.underwritingResult;
        _this.generateText = function () {
            // we need to filter UW086 (if it exist) from another ones to get single UW fail message
            _this.checkOnMissingPolicyHolderRule();
            if (_this.underwritingResultArray.length > 1) {
                if (_this.isMotorProduct || _this.isWolfMotorProduct) {
                    return _this.renderWordingsOfMultipleMotorUW();
                }
                if (_this.isRentersProduct || _this.isMultiProduct) {
                    return _this.renderGenericDeclineText();
                }
            }
            if (_this.underwritingResultArray.length === 1 && _this.underwritingResultArray[0].objectName === "UW093") {
                return React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "Green card length exceeded.");
            }
            if (_this.underwritingResultArray.length === 1) {
                return _this.renderWordingsOfOneUW(_this.underwritingResultArray[0].objectName);
            }
            if (_this.isHomeProduct) {
                return _this.renderGenericHomeMessage();
            }
            return React.createElement("p", null,
                "Sorry...",
                React.createElement("br", null),
                "...we can't insure you.");
        };
        _this.renderWordingsOfOneUW = function (underwritingRule) {
            var declineText;
            if (_this.isMultiProduct) {
                declineText = underwritingRule.startsWith("UR") ? new RentersDeclineText_1.RentersDeclineText() : new MotorDeclineText_1.MotorDeclineText(_this.props);
            }
            else if (_this.isMotorProduct) {
                declineText = new MotorDeclineText_1.MotorDeclineText(_this.props);
            }
            else if (_this.isRentersProduct) {
                declineText = new RentersDeclineText_1.RentersDeclineText();
            }
            else if (_this.isWolfMotorProduct) {
                declineText = new WolfMotorDeclineText_1.WolfMotorDeclineText(_this.props);
            }
            else if (_this.isHomeProduct) {
                declineText = new HomeDeclineText_1.HomeDeclineText();
            }
            else {
                return React.createElement(React.Fragment, null);
            }
            for (var _i = 0, _a = declineText.underwritingResultCustomerWordings; _i < _a.length; _i++) {
                var uw = _a[_i];
                if (uw.key === underwritingRule) {
                    return (uw.value);
                }
            }
            return _this.renderGenericHomeMessage();
        };
        _this.renderWordingsOfMultipleMotorUW = function () {
            var driversWithUWs = [];
            _this.underwritingResultArray.forEach(function (uw) {
                if (uw.objectReference && uw.objectReference.objectName === "additionalDrivers") {
                    driversWithUWs.push(_this.props.interaction.additionalDrivers[uw.objectReference.index]);
                }
                else if (uw.objectReference && uw.objectReference.objectName === "policyHolder") {
                    driversWithUWs.push(_this.props.interaction.policyHolder);
                }
            });
            var uniqueDrivers = driversWithUWs.map(function (driver) { return React.createElement("li", { key: driver.personId },
                driver.firstName,
                " ",
                driver.lastName); })
                .filter(function (v, i, a) { return a.findIndex(function (el) { return el.key === v.key; }) === i; });
            if (_this.isWolfMotorProduct) {
                return React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.");
            }
            else if (uniqueDrivers.length > 0) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("p", null,
                        "Sorry...",
                        React.createElement("br", null),
                        "...we can't offer you a quote because we can't insure driver(s):"),
                    React.createElement.apply(React, __spreadArray(["ul", null], uniqueDrivers, false)),
                    React.createElement("p", null, "If you'd like to continue with your quote, please remove these drivers.")));
            }
            else {
                return (React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."));
            }
        };
        _this.renderGenericDeclineText = function () {
            return (React.createElement("p", null,
                "Sorry we can't insure you...",
                React.createElement("br", null),
                "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote. This may be because of discrepancies in your application.",
                React.createElement("br", null),
                React.createElement("br", null),
                "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                React.createElement("br", null)));
        };
        _this.showBackButton = _this.getSetting("showBackButton", true);
        _this.isMotorProduct = services_1.productHelper.isMotor(_this.props.interaction);
        _this.isRentersProduct = services_1.productHelper.isRenters(_this.props.interaction);
        _this.isMultiProduct = services_1.productHelper.isMultiProduct(_this.props.interaction);
        _this.isWolfMotorProduct = services_1.productHelper.isWolfMotor(_this.props.interaction);
        _this.isHomeProduct = services_1.productHelper.isHome(_this.props.interaction);
        _this.goBack = _this.goBack.bind(_this);
        _this.textToDisplay = _this.generateText();
        return _this;
    }
    DeclineTextOutputWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-group declineTextWidget" },
                React.createElement("h1", null, "Sorry, we can\u2019t insure you..."),
                React.createElement("div", { className: "panel" }, this.textToDisplay)),
            this.showBackButton && this.renderBackButton()));
    };
    DeclineTextOutputWidget.prototype.renderBackButton = function () {
        return (React.createElement("button", { type: "button", role: "link", className: "btn btn-back", onClick: this.goBack, id: "decline-page-back" }, "Back"));
    };
    DeclineTextOutputWidget.prototype.renderGenericHomeMessage = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote."),
            React.createElement("p", null,
                "No worries though, our friends at Gallaghers might be able to help. You can contact them about their specialist insurance on:",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "tel:+44 333 188 7823", "aria-label": "Phone number +44 333 188 7823" }, "0333 188 7823")),
            React.createElement("p", null,
                "Or you can take a look on the",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank" }, "BIBA website"),
                ' ',
                "to find providers who may offer cover.")));
    };
    DeclineTextOutputWidget.prototype.goBack = function () {
        if (this.props.interaction.uistate) {
            this.props.onStateChange("uistate.specificUwRuleTriggered", false);
        }
        var journeyState = this.props.engine.getJourneyState();
        var declineReferrerPage = journeyState.declineReferrerPage;
        if (declineReferrerPage === 'quoteSummary') {
            declineReferrerPage = 'quote';
        }
        this.props.engine.setJourneyState({
            declineReferrerPage: undefined
        });
        if (declineReferrerPage) {
            this.props.engine.navigate(declineReferrerPage, false);
        }
    };
    DeclineTextOutputWidget.prototype.checkOnMissingPolicyHolderRule = function () {
        var containsMissingPolicyHolder = this.underwritingResultArray.some(function (rule) { return rule.objectName === "UW086"; });
        if (containsMissingPolicyHolder) {
            this.underwritingResultArray = this.underwritingResultArray.filter(function (rule) {
                return rule.objectName !== "UW080";
            });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], DeclineTextOutputWidget.prototype, "journeyRuntimeService", void 0);
    return DeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=DeclineTextOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/DeclineTextOutputWidget.js
// module id = 3654
// module chunks = 0